<template lang="html">
    <div class="d-flex flex-wrap">
        <button
            type="button"
            v-for="paymentMethod in filteredPaymentMethods"
            :key="paymentMethod.id"
            class="payMethodBtn btn bg-lightest darker bold mr-2 mb-2"
            :class="{ 'selected': paymentMethod.id == value, 'disabled': paymentMethod.disabled }"
            :disabled="paymentMethod.disabled"
            @click="selectPayMethod(paymentMethod)"
        >
            {{ paymentMethod.description }}
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'PaymentMethodSelector',
    props: {
        value: {
            type: Number,
        },
        allowedMethods: {
            type: Array,
            default: null,
        },
    },
    computed: {
        ...mapGetters([
            'getPaymentTypeListAll',
        ]),
        filteredPaymentMethods() {
            return this.getPaymentTypeListAll.map(paymentMethod => {
                paymentMethod.disabled = this.allowedMethods != null && !this.allowedMethods.includes(paymentMethod.id)
                return paymentMethod
            })
        },
    },
    methods: {
        selectPayMethod(paymentMethod) {
            if (paymentMethod.disabled) {
                return
            }

            this.$emit('input', paymentMethod.id)
            this.$emit('change', paymentMethod.id)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
@import '~@/assets/scss/_utility.scss';

.payMethodBtn {
    @extend .border-medium;
    height: 40px;
    border-radius: 0.4rem !important;

    &:hover {
        @extend .bg-lighter;
    }

    &.selected {
        border-color: $color-1 !important;
        background-color: rgba($color-1, 0.12) !important;
    }

    &.disabled {
        opacity: 0.5;
        background-color: $light;
        cursor: not-allowed !important;
    }
}
</style>



// WEBPACK FOOTER //
// PaymentMethodSelector.vue?2a024f44